// Deep import: the `validator` barrel is ~280kB of validators we never call.
import isFQDN from "validator/lib/isFQDN";
import * as yup from "yup";

import type { INTERVAL, ISO8601, ISO8601_DATE } from "./iso8601";
import type { UUID } from "./uuid";

yup.addMethod(yup.string, "domain", function domain(errorMessage: string) {
  return this.test("test-is-domain", errorMessage, function isDomain(value?: string) {
    const { path, createError } = this;
    return (value && isFQDN(value)) || createError({ path, message: errorMessage });
  });
});

yup.addMethod(yup.string, "url_or_merge_tag", function urlOrMergeTag(errorMessage: string) {
  return this.test("test-is-url-or-merge-tag", errorMessage, function isUrlOrMergeTag(value) {
    const { path, createError } = this;
    const error = createError({ path, message: errorMessage });

    if (!value) return error;

    const hasMergeTag = Boolean(value?.match(/{{[^}}]+}}/g));

    if (hasMergeTag && value?.startsWith("{{")) return true;

    if (!hasMergeTag) return yup.string().url().isValidSync(value) || error;

    try {
      const url = new URL(value);
      return url.protocol !== "";
    } catch {
      // URL errors if no protocol is provided
      return error;
    }
  });
});

declare module "yup" {
  interface StringSchema<TType, TContext> {
    domain: (errorMessage: string) => StringSchema<TType, TContext>;
    url_or_merge_tag: (errorMessage: string) => StringSchema<TType, TContext>;
    validMergeTags: (errorMessagePrefix: string) => StringSchema<TType, TContext>;
  }
}

export default yup;

export const yupUUID = yup.string<UUID>();
export const yupISO8601Date = yup.string<ISO8601_DATE>();
export const yupISO8601 = yup.string<ISO8601>();
type OptionalInterval = INTERVAL | "never";
export const yupInterval = yup.string<OptionalInterval>();
